import { HomeV2 } from "@/components/Home";

export default function index() {
  return ( <HomeV2 />);
}





